import React, { Component } from 'react'
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CardContent from "@mui/material/CardContent";

import Grid from "@mui/material/Grid";
import MuiAlert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { GradientButton } from '../GradientButton';
import { Button, DialogContent, DialogContentText } from '@mui/material';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import '../../../styles/components.css';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Snackbar from '@mui/material/Snackbar';
import axios from 'axios';
import InputAdornment from '@mui/material/InputAdornment';
import PoundIcon from "../../../images/pound.png";
import { getURLBase, updateHeightAfterContentUpdate } from '../../../utils/helperFns';
import theme from "../../../styles/customTheme";
import { SavingsEnvelopesImages } from '../../../utils/mockData';

const images = SavingsEnvelopesImages;

export class SweepAccountDetails extends Component {
    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/sweepaccountdetailsnew";
        this.state = {
            openDialog: false,
            saved: 0,
            save_now: 0,
            ready: false,
            sweepInputValue: this.props.max_save,
            sweepFormValidation: null,
            buttonCheckInProgress: false,
            savingsEnvelope: [],
            intervalId: null,
            sweep_balance: 0,
            msg: "",
            open: false,
            tutorial_iframe: ""
        };
    }

    toggleOpen = (msg, secondMsg = null, img="success.gif") => {
        this.setState({ open: !this.state.open, msg: msg, secondMsg: secondMsg, img: img });
    }
    handleBoxClose = () => {
        this.setState({ open: false });
    };

    componentDidMount() {
        //--original response (uncomment this when api is implemented)
        axios.post(getURLBase(true) + "/totalbalance", { gid: this.props.gid }).then(
            (response) => {
                var sweepAccount = response.data.body.categories.pop();
                this.setState({ sweep_balance: sweepAccount.total })
            }
        )

        axios.post(this.url, { gid: this.props.gid }).then(
            (res) => {
                console.log("sweep details - ", res)
                this.setState({
                    savingsEnvelope: res.data.body.details,
                    max_save: res.data.body.max_save,
                    sweepInputValue: res.data.body.save_now,
                    max_to_sweep: res.data.body.max_to_sweep,
                    save_now: res.data.body.save_now,
                    saved_so_far: res.data.body.saved_so_far,
                    tutorial_iframe: res.data.body.tutorial_iframe,
                    ready: true
                })
            });

    }

    handleClickOpen = () => {
        this.setState({ openDialog: true })
    };

    handleClose = (value) => {
        this.setState({ openDialog: false })
    };

    changeSweepInputValue = (event) => {
        this.setState({ sweepInputValue: event.target.value });
    }

    sendTransferSweepRequest = () => {
        this.setState({ sweepFormValidation: null });
        const sweeepValue = document.getElementById("sweepSave").value;

        if (sweeepValue <= this.props.max_save) {
            if (sweeepValue == null || sweeepValue < 1) {
                this.setState({ sweepFormValidation: "Sweep value must be greater than 0" });
            }
            else {
                let finalValue = sweeepValue;

                if (this.state.buttonCheckInProgress) {
                    this.setState({ showErrorSnackbar: true });
                    console.log("Button check already in progress");
                    //wait logic for getting button state
                    setTimeout(() => {
                        this.postTransferSweepRequest(finalValue);
                    }, 2000);
                }
                else {
                    this.setState({ buttonCheckInProgress: false }, () => { console.log("Checking button state from sendTransferSweepRequest method") });
                    this.postTransferSweepRequest(finalValue);
                }
            }
        }
        else {
            this.setState({ sweepFormValidation: "Amount greater than current account balance that is available to sweep" });
        }
    };

    sendWithdrawSweepRequest = () => {
        this.setState({ sweepFormValidation: null });
        const sweeepValue = document.getElementById("sweepSave").value;

        if (sweeepValue <= this.state.sweep_balance) {
            let finalValue = 0;
            if (sweeepValue == null || sweeepValue < 1) {
                this.setState({ sweepFormValidation: "Sweep value must be greater than 0" });
            }
            else {
                finalValue = sweeepValue;

                if (this.state.buttonCheckInProgress) {
                    this.setState({ showErrorSnackbar: true });
                    console.log("Button check already in progress");
                    //wait logic for getting button state
                    setTimeout(() => {
                        this.postWithdrawSweepRequest(finalValue);
                    }, 2000);
                }
                else {
                    this.setState({ buttonCheckInProgress: false }, () => { console.log("Checking button state from sendWithdrawSweepRequest method") });

                    this.postWithdrawSweepRequest(finalValue);

                }
            }
        }
        else {
            this.setState({ sweepFormValidation: "Amount greater than sweep account balance" });
        }
    };

    postTransferSweepRequest = (finalValue) => {
        console.log("calling postTransferSweepRequest");
        axios.post(getURLBase(true) + '/transfer_sweep_balance', {
            "gid": this.props.gid,
            "amount": finalValue
        }).then(res => {
            console.log("Sweep transfer response - ", res.data);
            const is_failed = res.data.status == "failed";
            if (is_failed) {
                this.toggleOpen("This operation cannot be completed at ","this time as your earlier operation is in progress.", "error.png")

            } else {
                this.toggleOpen("The balance transfer has been intiated.", " This action will be completed soon. Look out for an email!");
            }

            setTimeout(() => {
                this.toggleOpen("");
            }, 6251);

        }
        ).catch(err => {
            // request failed
            console.log("postTransferSweepRequest exception occured");
        });

    }

    postWithdrawSweepRequest = (finalValue) => {
        console.log("calling postWithdrawSweepRequest");
        axios.post(getURLBase(true) + '/withdraw_sweep_balance', {
            "gid": this.props.gid,
            "amount": finalValue
        }).then(res => {
            console.log("Sweep Withdraw response - ", res.data);
            const is_failed = res.data.status == "failed";
            if (is_failed) {
                this.toggleOpen("This operation cannot be completed at ","this time as your earlier operation is in progress.", "error.png")

            } else {
                this.toggleOpen("The balance withdrawal has been intiated.", " This action will be completed soon. Look out for an email!")
            }

            setTimeout(() => {
                this.toggleOpen("");
            }, 6251);
        }
        ).catch(err => {
            // request failed
            console.log("postWithdrawSweepRequest exception occured");
        });
    }

    render() {

        const InfoDialog = () => (
            <Dialog onClose={this.handleClose} open={this.state.openDialog}>

                <DialogTitle sx={{ margin: 0 }}>What does Transfer to Sweep means</DialogTitle>
                <Divider light />
                <CardContent>
                    <Typography variant="body2" marginBottom={4} fontWeight={600}>
                        Makes a ‘virtual transfer’ to your SWEEP account. It indicates the amount that you can save right now from your connected bank account(s) into the SWEEP account and still be able to meet your monthly expenses as per our spending forecast. Once transferred to the SWEEP account, the savings will be automatically allocated into Savings Envelopes. SWEEP balance and Savings Envelope balance shows a virtual balance and not a real balance.
                    </Typography>

                    <Typography variant="body2" fontWeight={600}>
                        Clicking on ‘Transfer to SWEEP’ won’t move any actual money from your connected bank account(s) now. We will soon add the ability to move money from your bank account(s) to save in your SWEEP account.
                    </Typography>
                </CardContent>
            </Dialog>
        );

        const Alert = React.forwardRef(function Alert(props, ref) {
            return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
        });

        return (
            <>
                <Box className="popup" id="child_SweepAccountDetails">
                    <Grid mx={"auto"}>
                        <Box className="popupClose">
                            <IconButton aria-label="Close" onClick={this.props.toggleHandler}>
                                <ArrowBackIcon />
                            </IconButton>
                        </Box>
                        <CardContent textAlign="center">
                            <Box className="popupHeader">
                                <Typography gutterBottom align="center" variant="h4" fontWeight={700}>
                                    SWEEP Balance
                                </Typography>

                                <Typography gutterBottom align="center" variant="h2" fontSize="2rem" fontWeight={700}>
                                    £{this.state.sweep_balance}
                                </Typography>
                            </Box>
                            <Box className="popupBody" pt={{ xs: 12, sm: 0 }}>
                                <Grid container spacing={2} py={2}>
                                    <Grid item md={6} mx="auto">
                                        <Stack
                                            direction="column"
                                            alignItems="center"
                                            spacing={2}
                                            sx={{ height: "100%" }}
                                        >
                                            <Stack>
                                                <Typography variant="h4" fontWeight={700} align="center" className="text-capitalize" gutterBottom>Save now</Typography>

                                                <Grid container justifyContent="center">
                                                    <Grid item sm={6} xs={8} align="center">
                                                        <TextField className="sweepInput" id="sweepSave" variant="standard"
                                                            value={this.state.sweepInputValue}
                                                            onChange={this.changeSweepInputValue}
                                                            maxiumumValue={this.state.max_to_sweep}
                                                            type="number"
                                                            minimimumValue={1}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <img src={PoundIcon} width={24} alt="" />
                                                                    </InputAdornment>
                                                                ),
                                                            }}

                                                        />
                                                        {
                                                            this.state.sweepFormValidation && <Typography color={theme.palette.error.main} variant="caption" fontWeight={700}>
                                                                <span className="text-capitalize">{this.state.sweepFormValidation}</span>
                                                            </Typography>
                                                        }

                                                        <Stack direction="row" alignItems="center" justifyContent="center" marginTop={2}>
                                                            <GradientButton sx={{ fontWeight: 800, minWidth: "110%", marginLeft: "50px" }} onClick={this.sendTransferSweepRequest} textTransformtype="capitalize">
                                                                Transfer to SWEEP
                                                            </GradientButton>



                                                            <Button sx={{ padding: 0 }} variant="text" onClick={this.handleClickOpen} >
                                                                <HelpOutlineIcon color="secondary" />
                                                            </Button>

                                                        </Stack>
                                                    </Grid>
                                                </Grid>
                                            </Stack>
                                            <Button sx={{
                                                margin: "0 auto",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                marginBottom: "0.2rem !important",
                                                marginTop: "0.2rem !important",
                                                // fontSize: "0.7rem",
                                                padding: "2px"
                                            }}
                                                onClick={() => this.props.setEmbedUrl(this.state.tutorial_iframe)}
                                            >
                                                See how this works <img src="/tutorial-icon.png" style={{ width: "40px", padding: "5px" }} alt="" />
                                            </Button>

                                            <Button variant="outlined" color="error" onClick={this.sendWithdrawSweepRequest}>
                                                Withdraw
                                            </Button>
                                        </Stack>



                                    </Grid>
                                    <Grid item md={6} mx="auto" pr={{ xs: 0, md: 2 }} mt={{ xs: 2, md: 0 }}>
                                        <Typography variant="h5" mb={3} align="center" gutterBottom>
                                            Allocation of SWEEP balance
                                        </Typography>


                                        <Stack justifyContent="space-between" direction="row">
                                            <Typography variant="body1" fontWeight={700} color="text.secondary" align="center" gutterBottom>
                                                Savings Envelope
                                            </Typography>
                                            <Typography variant="body1" fontWeight={700} color="text.secondary" align="center" gutterBottom>
                                                Balance
                                            </Typography>
                                        </Stack>

                                        {this.state.ready && this.state.savingsEnvelope.map((el) => (
                                            <Box mt={1}>
                                                <Stack justifyContent="space-between" alignItems="center" direction="row" key={el.name} pb={1}>
                                                    <Stack direction="row" alignItems="center">
                                                        <Avatar alt={el.text} src={images[el.img]} />
                                                        <Typography variant="body2" mb={0} fontWeight={700} ml={1} className="text-uppercase" align="center" gutterBottom>
                                                            {el.name}
                                                        </Typography>
                                                    </Stack>
                                                    <Typography variant="h5" mb={0} align="center" gutterBottom>
                                                        £ {el?.balance.toFixed(2)}
                                                    </Typography>

                                                </Stack>
                                                <Divider light />
                                            </Box>
                                        ))

                                        }

                                    </Grid>
                                </Grid>
                            </Box>
                            {updateHeightAfterContentUpdate("parent_TotalBalance", "child_SweepAccountDetails")}
                        </CardContent>
                    </Grid>
                </Box>

                <InfoDialog
                    open={this.state.openDialog}
                    onClose={this.handleClose}
                />

                <Dialog
                    open={this.state.open}
                    onClose={this.handleBoxClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{ borderRadius: "30px" }}
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description" className="font-medium">
                            <img src={`/${this.state.img}`} style={{ display: "block", margin: "auto" }} alt="" />
                            <p style={{ marginTop: "-20px", margin: "auto", textAlign: "center", fontWeight: 900 }}>{this.state.msg}{
                                this.state.secondMsg ? (<><br /> {this.state.secondMsg} </>) : null
                            }</p>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    autoHideDuration={3000}
                    open={this.state.showErrorSnackbar}
                    onClose={() => this.setState({ showErrorSnackbar: false })}
                    key={"sweepErrorSnackbar"}
                >
                    <Alert severity="error" onClose={() => this.setState({ showErrorSnackbar: false })}> Sweep operation already in progress</Alert>
                </Snackbar>
            </>
        );
    }
}

export default SweepAccountDetails
